import { Flex, Grid, Layout, theme } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { Content } from 'antd/es/layout/layout';
import { Suspense, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import LeftIcon from 'src/assets/icons/left.png';
import RightIcon from 'src/assets/icons/right.png';
import Icon from 'src/components/v2/Icon';
import urlPath from 'src/constants/urlPath';
import { AppContext } from 'src/contexts/app.context';
import { HrTicketDetailProvider } from 'src/contexts/hrTicketDetail.context';
import AdditionalWorkingTimeTicketDetail from 'src/pages/v2/HrTicket/AdditionalWorkingTimeTicketDetail';
import AdvancePaymentTicketDetail from 'src/pages/v2/HrTicket/AdvancePaymentTicketDetail';
import BusinessTripTicketDetail from 'src/pages/v2/HrTicket/BusinessTripTicketDetail';
import EquipmentSupplyRequestTicketDetail from 'src/pages/v2/HrTicket/EquipmentSupplyRequestTicketDetail';
import ExpenseTrackingRequestTicketDetail from 'src/pages/v2/HrTicket/ExpenseTrackingRequestTicketDetail';
import LeaveTicketDetail from 'src/pages/v2/HrTicket/LeaveTicketDetail';
import LeavePackageDetail from 'src/pages/v2/HrTicket/LeavePackageDetail';
import OvertimeTicketDetail from 'src/pages/v2/HrTicket/OvertimeTicketDetail';
import TransportationTicketDetail from 'src/pages/v2/HrTicket/TransportationTicketDetail';
import Sidebar from 'src/pages/v2/HrTicket/components/HrSidebar';
import HandoverTicketDetail from 'src/pages/v2/OfficeTicket/HandoverTicketDetail';
import ResignationTicketDetail from 'src/pages/v2/HrTicket/ResignationTicketDetail';

const { useBreakpoint } = Grid;

const HrTicketDetailLayout = () => {
  const { isDetailSidebarCollapsed, isTicketDetailCollapsed, setIsDetailSidebarCollapsed } = useContext(AppContext);
  const location = useLocation();
  const screens = useBreakpoint();

  const {
    token: { colorBgContainer }
  } = theme.useToken();

  const handleCollapseSider = () => {
    setIsDetailSidebarCollapsed(!isDetailSidebarCollapsed);
  };

  const renderHrTicketDetail = () => {
    const routes = [
      {
        paths: [urlPath.leavePackageApproval.location, urlPath.myLeavePackage.location],
        component: <LeavePackageDetail />
      },
      {
        paths: [urlPath.leaveTicket.location, urlPath.leaveTicketSub.location, urlPath.hrConfirmLeaveTicket.location],
        component: <LeaveTicketDetail />
      },
      { paths: [urlPath.advancePaymentTicket.location], component: <AdvancePaymentTicketDetail /> },
      {
        paths: [urlPath.overtimeTicket.location, urlPath.hrConfirmOvertimeTicket.location],
        component: <OvertimeTicketDetail />
      },
      {
        paths: [urlPath.expenseTrackingRequestTicket.location, urlPath.hrConfirmExpenseTrackingRequestTicket.location],
        component: <ExpenseTrackingRequestTicketDetail />
      },
      { paths: [urlPath.handoverTicket.location], component: <HandoverTicketDetail /> },
      {
        paths: [urlPath.businessTripTicket.location, urlPath.hrConfirmBusinessTripTicket.location],
        component: <BusinessTripTicketDetail />
      },
      {
        paths: [urlPath.transportationTicket.location, urlPath.hrConfirmTransportationTicket.location],
        component: <TransportationTicketDetail />
      },
      { paths: [urlPath.equipmentSupplyRequestTicket.location], component: <EquipmentSupplyRequestTicketDetail /> },
      {
        paths: [urlPath.additionalWorkingTimeTicket.location, urlPath.hrConfirmAdditionalWorkingTimeTicket.location],
        component: <AdditionalWorkingTimeTicketDetail />
      },
      {
        paths: [
          urlPath.resignationTicket.location,
          urlPath.resignationTicketSub.location,
          urlPath.hrConfirmResignationTicket.location
        ],
        component: <ResignationTicketDetail />
      }
    ];

    const route = routes.find((route) => route.paths.some((path) => location.pathname.includes(path)));
    return route ? route.component : null;
  };

  return (
    <Sider
      className='ticket-detail-layout'
      trigger={null}
      width={`calc(100% - ${screens.xxl ? '400px' : '320px'})`}
      collapsible
      collapsed={isTicketDetailCollapsed}
      style={{ background: colorBgContainer }}
      collapsedWidth={0}
    >
      <Layout hasSider>
        <HrTicketDetailProvider>
          <Content>
            <Suspense>{renderHrTicketDetail()}</Suspense>
          </Content>
          <Sider
            trigger={null}
            width={screens.xxl ? '320px' : '280px'}
            collapsible
            collapsed={isDetailSidebarCollapsed}
            style={{ background: colorBgContainer }}
            collapsedWidth={50}
          >
            <div className='ticket-detail-sidebar'>
              <Flex className='hide-icon' justify='left' onClick={handleCollapseSider}>
                <Icon
                  url={isDetailSidebarCollapsed ? LeftIcon : RightIcon}
                  size={20}
                  titleTooltip={isDetailSidebarCollapsed ? 'Mở cây phê duyệt' : 'Đóng'}
                  placementTooltip='bottom'
                  open={isDetailSidebarCollapsed && !isTicketDetailCollapsed ? true : false}
                  styleTooltip={{ fontSize: '11px', padding: '5px', maxWidth: '50px' }}
                />
              </Flex>
              {!isDetailSidebarCollapsed && (
                <Flex vertical gap={20}>
                  <Sidebar />
                </Flex>
              )}
            </div>
          </Sider>
        </HrTicketDetailProvider>
      </Layout>
    </Sider>
  );
};

export default HrTicketDetailLayout;
